import firebase from '../helper/firebase';
import _ from 'lodash';
import { GetFCMToken } from '../helper/functions';

const initialState = {
	uid: '',
	auth: {},
	user: {},
	loggedIn: false,
	authLoading: true,
	profileLoading: true,

	admin: false,
	adminLoading: true,

	// unverified:false,
	verificationEmailMessage: '',

	notifications: null,

	skills: {},
	skillsLoading: true,

	snack: false,
	snackMessage: ''
};

//Actions
const AUTHENTICATE = 'UserState/AUTHENTICATE';
const UNAUTHENTICATED = 'GlobalState/UNAUTHENTICATED';

const GET_PROFILE = 'UserState/GET_PROFILE';
const GET_PROFILE_FAILED = 'UserState/GET_PROFILE_FAILED';

const GET_ADMINSTATUS = 'UserState/GET_ADMINSTATUS';

const GET_NOTIFICATIONS = 'UserState/GET_NOTIFICATIONS';

const GET_SKILLS = 'UserState/GET_SKILLS';

const GET_JOB = 'JobState/GET_JOB';

const SET_SNACK = 'GlobalState/SET_SNACK';

export function getProfileInfo(uid) {
	// console.log(uid);
	return (dispatch, getState) => {
		firebase
			.database()
			.ref(`users/${uid}`)
			.once('value')
			.then(user => {
				let data = user.val();
				if (!data) return;
				dispatch({ type: GET_PROFILE, payload: data });
			})
			.catch(profileErr => {
				dispatch({ type: GET_PROFILE_FAILED });
			});
	};
}

let parseJwt = token =>
	JSON.parse(
		window.atob(
			token
				.split('.')[1]
				.replace('-', '+')
				.replace('_', '/')
		)
	);
// function parseJwt (token) {
//   var base64Url = token.split('.')[1];
//   var base64 = base64Url.replace('-', '+').replace('_', '/');
//   return JSON.parse(window.atob(base64));
// };

// export function getAdminStatus(uid) {
//   return (dispatch, getState) => {
//     firebase
//       .auth()
//       .currentUser.getIdToken()
//       .then(idToken => {
//         const payload = parseJwt(idToken);
//         if (!!payload["admin"]) {
//           dispatch({ type: GET_ADMINSTATUS, payload: true });
//         } else {
//           dispatch({ type: GET_ADMINSTATUS, payload: false });
//         }
//       });
//   };
// }

export function setAdminStatus() {
	return (dispatch, getState) => {
		dispatch({ type: GET_ADMINSTATUS, payload: true });
	};
}

export function setUserStatus() {
	return (dispatch, getState) => {
		dispatch({ type: GET_ADMINSTATUS, payload: false });
	};
}

export function getUserCustomClaims(user) {
	return (dispatch, getState) => {
		firebase
			.auth()
			.currentUser.getIdToken()
			.then(idToken => {
				const payload = parseJwt(idToken);
				if (!!payload['admin']) {
					dispatch(setAdminStatus());
				}
				if (!!payload['admin']) {
					dispatch(getMyJobs(user));
				}
				if (!payload['admin']) {
					dispatch(getMyInvites(user));
				}
				if (!payload['admin']) {
					dispatch(setUserStatus());
				}
				// if (!payload["admin"]) {dispatch(getMyListener([{uid:'',stateName:'invited',dbName:'invited',dispatchName:'JobsState/GET_INVITED',getJobs:true}]))}
			});
	};
}

export function getMyInvites(user) {
	return (dispatch, getState) => {
		let invited = getState().jobs['invited'];
		if (!_.isEmpty(invited)) {
			Object.keys(invited)
				.map(jid => invited[jid])
				.forEach(job => dispatch(getJob(job.jid)));
			return;
		} else {
			// detachers.push(
			//   firebase.database().ref(`${myJobs}/${user.uid}`)
			// );
			firebase
				.database()
				.ref(`invited/${user.uid}`)
				.on(
					'value',
					snap => {
						if (!!snap.val()) {
							dispatch({ type: 'JobsState/GET_INVITED', payload: snap.val() });
							snap.forEach(myJob => dispatch(getJob(myJob.val().jid)));
						} else {
							dispatch({ type: 'JobsState/GET_INVITED', payload: {} });
							// dispatch({ type: GET_JOB, payload: getState().jobs.jobs });
						}
					},
					err => {
						console.log(err);
					}
				);
		}
	};
}

export function getMyJobs(user) {
	return (dispatch, getState) => {
		let myJobs = getState().jobs['myJobs'];
		if (!_.isEmpty(myJobs)) {
			Object.keys(myJobs)
				.map(jid => myJobs[jid])
				.forEach(job => dispatch(getJob(job.jid)));
			return;
		} else {
			// detachers.push(
			//   firebase.database().ref(`${myJobs}/${user.uid}`)
			// );
			firebase
				.database()
				.ref(`myJobs/${user.uid}`)
				.on(
					'value',
					snap => {
						if (!!snap.val()) {
							dispatch({ type: 'JobsState/GET_MYJOBS', payload: snap.val() });
							snap.forEach(myJob => dispatch(getJob(myJob.val().jid)));
						} else {
							dispatch({ type: 'JobsState/GET_MYJOBS', payload: {} });
							dispatch({ type: GET_JOB, payload: getState().jobs.jobs });
						}
					},
					err => {
						console.log(err);
					}
				);
		}
	};
}

export function getJob(jid) {
	return (dispatch, getState) => {
		let jobs = getState().job;
		if (!jobs[jid]) {
			getJobPromise(jid)
				.then(data => dispatch({ type: GET_JOB, payload: data, jid }))
				.catch(error => setSnack(true, error));
		}
	};
}

export function getJobPromise(jid) {
	return new Promise((resolve, reject) => {
		firebase
			.firestore()
			.collection('jobs')
			.doc(jid)
			.get()
			.then(snap => resolve(snap.data()))
			.catch(error => reject(Error(error)));
	});
}

export function setNotificationsListener(uid) {
	return (dispatch, getState) => {
		firebase
			.database()
			.ref(`userNotifications/${uid}`)
			.on('value', snap => {
				let data = {};
				if (snap.val() !== null) {
					data = snap.val();
				} else {
					data = null;
				}
				dispatch({ type: GET_NOTIFICATIONS, payload: data });
			});
	};
}

export function setSnack(snackStatus, snackMessage) {
	return (dispatch, getState) => {
		let snack = { snackStatus, snackMessage };
		dispatch({ type: SET_SNACK, payload: snack });
	};
}

//non redux functions being setup i.e. functions that don't set any state
export function tokenRefreshListener(uid) {
	firebase.messaging().onTokenRefresh(() => {
		GetFCMToken(uid);
	});
}

export function handlePresense(uid) {
	const ref = firebase.database().ref();
	ref.child(`users/${uid}/online`).on('value', snap => {
		if (!!snap.val()) {
			// console.log('online');
			ref
				.child(`users/${uid}/`)
				.onDisconnect()
				.update({ online: false });
		} else {
			// console.log('offline');
			ref.child(`users/${uid}/`).update({ lastSeen: Date.now(), online: true });
		}
	});
}

// export function setupFirestoreListeners(url) {
//   return(dispatch,getState) => {
//     firebase.auth().onAuthStateChanged(user=>{
//       if(user){
//         dispatch(setupFirestoreListener(url))
//       }
//     })
//     // firebase.database().ref(`skills/${user.uid}`)
//   }
// }

export function setupFirestoreListener(url, dispatchName) {
	return (dispatch, getState) => {
		// if(_.isEmpty(getState().user.skills))return
		firebase
			.firestore()
			.doc(url)
			.onSnapshot(snap => {
				if (!!snap.data()) {
					dispatch({ type: dispatchName, payload: snap.data() });
				} else {
					dispatch({ type: dispatchName, payload: {} });
				}
			});
	};
}

export function setupAuthListener() {
	return (dispatch, getState) => {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				dispatch({ type: AUTHENTICATE, payload: user });
				dispatch(getProfileInfo(user.uid)); // causes FIREBASE WARNING: Invalid query string segment:
				// dispatch(getAdminStatus(user.uid));
				dispatch(getUserCustomClaims(user));
				dispatch(setNotificationsListener(user.uid)); // causes FIREBASE WARNING: Invalid query string segment:
				tokenRefreshListener(user.uid);
				handlePresense(user.uid); // causes FIREBASE WARNING: Invalid query string segment:
				dispatch(setupFirestoreListener(`skills/${user.uid}`, GET_SKILLS));
				// firebase.messaging().onMessage((payload)=>{console.log("Message received. ", payload);});
				// this.ensureProfileUpdated(user.uid,user.providerData[0]);
			} else {
				// if(this.state.uid){firebase.database().ref(`userNotifications/${this.state.uid}`).off()}
				// if(this.state.uid){firebase.database().ref(`users/${this.state.uid}/online`).off()}
				dispatch({ type: UNAUTHENTICATED });
			}
		});
	};
}

export default (state = initialState, action) => {
	switch (action.type) {
		case AUTHENTICATE:
			let auth = action.payload.providerData[0];
			auth.emailVerified = action.payload.emailVerified;
			return {
				...state,
				loggedIn: true,
				uid: action.payload.uid,
				auth,
				authLoading: false,
				emailVerified: auth.emailVerified
			};
		case UNAUTHENTICATED:
			return {
				...initialState,
				authLoading: false
			};

		case GET_PROFILE:
			return {
				...state,
				user: action.payload,
				profileLoading: false
			};

		case GET_PROFILE_FAILED:
			return {
				...state,
				profileLoading: false
			};

		case GET_ADMINSTATUS:
			return {
				...state,
				admin: action.payload,
				adminLoading: false
			};

		case GET_NOTIFICATIONS:
			return {
				...state,
				notifications: action.payload
			};

		case GET_SKILLS:
			return {
				...state,
				skills: action.payload,
				skillsLoading: false
			};

		case SET_SNACK:
			return {
				...state,
				snackStatus: action.payload.snackStatus,
				snackMessage: action.payload.snackMessage
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js